module.exports = __webpack_public_path__ + "img/logo-menu.c03ffc2a.png";